import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

interface Language {
  code: string;
  label: string;
}

interface LanguageDropdownProps {
  languages?: Language[];
  defaultValue?: string;
  onLanguageChange?: (languageCode: string) => void;
}

const defaultLanguages: Language[] = [
  { code: "en", label: "English" },
  { code: "hi", label: "Hindi" },
];

export function LanguageDropdown({
  languages = defaultLanguages,
  defaultValue = "en",
  onLanguageChange,
}: LanguageDropdownProps) {
  const { i18n } = useTranslation();

  const handleChange = (languageCode: string) => {
    void i18n.changeLanguage(languageCode);
    onLanguageChange?.(languageCode);
  };

  return (
    <Select
      defaultValue={i18n.language ?? defaultValue}
      onValueChange={handleChange}
    >
      <SelectTrigger className="w-auto border-gray-300 rounded-full px-6 py-2 h-8 hover:bg-gray-50 transition-colors">
        <div className="flex items-center gap-3">
          <Globe className="h-4 w-4 text-blue-500" strokeWidth={1.5} />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent className="rounded-lg bg-white">
        {languages.map((language) => (
          <SelectItem key={language.code} value={language.code}>
            <div className="flex items-center gap-3">
              <span className="text-14-medium-capitalize ">
                {language.label}
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
